module.exports = __webpack_public_path__ + "static/parade-2019-house03-d3fe22ac4d5606596b31838ec0cbe7c9.jpg";